import React from 'react';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom'; 
import { AuthProvider } from './AuthContext';
import './i18n';
import App from './App';
import 'bootstrap/dist/css/bootstrap.rtl.min.css';


const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter> 
      <AuthProvider>
        <App />
      </AuthProvider>
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);
